import '../styles/MyPurchases.css';
import 'react-circular-progressbar/dist/styles.css';

import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Button from '../components/atoms/Button';
import Freemium from './Freemium';
import GuidedLearner from './GuidedLearner';
import PeakPrep from './PeakPrep';
import QuickPrep from './QuickPrep';
import { logger } from '../utils/logger';

// import CircularProgress from '@mui/material/CircularProgress';
import 'react-circular-progressbar/dist/styles.css';
import { useNavigate } from 'react-router-dom';
import { usePricingPlans } from '../hooks/usePricingPlans';
import useIsMobile from '../hooks/ismobile.js';

const MyPurchases = () => {
	const navigate = useNavigate();
	const isMobile = useIsMobile();

	const { currentPlanStartDate: currentPlanStartDate } = useSelector(
		(state) => state.userDetails
	);
	const { planTierId: planTierId } = useSelector((state) => state.userDetails);

	const { pricingPlans, isLoading, error } = usePricingPlans();

	// Hardcoded values
	const [totalDays, setTotalDays] = useState(0);
	const [progress, setProgress] = useState(0);
	const [daysLeft, setDaysLeft] = useState(0);
	const [buttonLabel, setButtonLabel] = useState('');
	const [component, setComponent] = useState(null);

	const buildImage = () => {
		let totalDaysPassed = calculateDaysPassed(currentPlanStartDate);

		const { component, label, daysInSubscription } =
			getComponentAndLabelBasedOnTier(planTierId);
		setComponent(component);
		setButtonLabel(label);
		setTotalDays(daysInSubscription);

		const calculatedProgress = (totalDaysPassed / daysInSubscription) * 100;
		setProgress(calculatedProgress);
		setDaysLeft(Math.max(daysInSubscription - totalDaysPassed, 0));
	};

	const calculateDaysPassed = (currentPlanStartDate) => {
		const purchase = new Date(currentPlanStartDate);
		const today = new Date();

		const startDate = new Date(purchase.getFullYear(), purchase.getMonth(), purchase.getDate());
		const endDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());

		const diffTime = endDate - startDate;
		return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
	};

	const explorePlans = () => {
		logger.log('Explore Plans button clicked');
		navigate(`/plans-and-pricing`);
	};

	useEffect(() => {
		if (!isLoading) {
			buildImage();
		}
	}, [isLoading]);

	const getComponentAndLabelBasedOnTier = (planTierId) => {
		const plan = pricingPlans.find((plan) => plan.id === planTierId);
		const features = plan ? plan.features : [];
		const limitations = plan ? plan.limitations : '';

		switch (planTierId) {
			case 'FREE_TIER':
				return {
					component: <Freemium features={features} limitations={limitations} />,
					label: 'Explore Plans',
					daysInSubscription: 7,
				};
			case 'QUICK_PREP':
				return {
					component: <QuickPrep features={features} limitations={limitations} />,
					label: 'Explore Plans',
					daysInSubscription: 30,
				};
			case 'GUIDED_LEARNER':
				return {
					component: <GuidedLearner features={features} limitations={limitations} />,
					label: 'Explore Plans',
					daysInSubscription: 90,
				};
			case 'PEAK_PREP':
				return {
					component: <PeakPrep features={features} limitations={limitations} />,
					label: 'Explore Plans',
					daysInSubscription: 365,
				};
			default:
				return { component: <div>Invalid tier</div>, label: '', daysInSubscription: 0 };
		}
	};

	return (
		<div className="my-purchases-wrapper">
			{isLoading ? (
				<div
					className="loader-container"
					style={{
						height: 'calc(100% - 60px)',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<div className="loader"></div>
					<p>Loading...</p>
				</div>
			) : (
				<div className="my-purchases-container">
					<div className="my-purchases-text-container">{component}</div>
					{!isMobile ? (
						<div className="my-purchases-details-container">
							<div className="my-purchases-explore-plans-section">
								<Button
									label={buttonLabel}
									onClick={explorePlans}
									className="explore-plans-button"
								/>
							</div>
							<div className="my-purchases-details-purchase-date-section">
								<div>Purchase Date</div>
								<div>
									{new Date(currentPlanStartDate).toLocaleDateString('en-US', {
										year: 'numeric',
										month: 'long',
										day: 'numeric',
									})}
								</div>
							</div>
							<div className="my-purchases-details-days-used-section">
								<div className="days-left">Days Left</div>
								<div className="circular-progressbar-container">
									<CircularProgressbar
										value={progress}
										text={`${daysLeft}/${totalDays}`}
										strokeWidth={15}
										styles={buildStyles({
											pathColor: '#08BD80',
											textColor: 'black',
										})}
									/>
								</div>
							</div>
						</div>
					) : (
						<React.Fragment>
							<div className="my-purchases-details-container">
								<div className="my-purchases-details-left-section">
									<div className="my-purchases-explore-plans-section">
										<Button
											label={buttonLabel}
											onClick={explorePlans}
											className="explore-plans-button"
										/>
									</div>
									<div className="my-purchases-details-purchase-date-section">
										<div>Purchase Date</div>
										<div>
											{new Date(currentPlanStartDate).toLocaleDateString(
												'en-US',
												{
													year: 'numeric',
													month: '2-digit',
													day: '2-digit',
												}
											)}
										</div>
									</div>
								</div>

								<div className="my-purchases-details-right-section">
									<div className="my-purchases-details-days-used-section">
										<div className="days-left">Days Left</div>
										<div className="circular-progressbar-container">
											<CircularProgressbar
												value={progress}
												text={`${daysLeft}/${totalDays}`}
												strokeWidth={15}
												styles={buildStyles({
													pathColor: '#08BD80',
													textColor: 'black',
												})}
											/>
										</div>
									</div>
								</div>
							</div>
						</React.Fragment>
					)}
				</div>
			)}
		</div>
	);
};

export default MyPurchases;
